/**
 * I passi del tutorial guidato di Incoming/Outcoming > Scarico.
 *
 * Nessun preparativo: la pagina non ha menu ne' dialog da aprire, quindi non
 * serve nemmeno un `onStop` che la rimetta a posto.
 *
 * Tutto quello che sta sotto il campo del lettore compare solo dopo una lettura
 * andata a buon fine. Finche' non si e' scansionato nulla quei passi si
 * agganciano in basso e raccontano lo stesso cosa ci si trovera'.
 */
const at = name => `[data-tour-scope="warehouse-outcoming"] [data-tour="${name}"]`;

export function createWarehouseOutcomingTourSteps() {
	return [
		{
			body: "Questa e' la pagina gemella del Carico, al contrario: si scansiona e la giacenza scende di uno. Si usa per la merce che esce senza passare da un ordine - un reso al fornitore, un campione, un pezzo rotto, una vendita fatta di persona senza battere scontrino. Le uscite legate agli ordini, invece, il sistema le scala gia' per conto suo.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'Un pezzo fuori per ogni lettura',
		},
		{
			body: "Non c'e' niente da cliccare prima di leggere: la pagina ascolta la tastiera per intero, e un lettore barcode per il computer non e' altro che una tastiera che digita in fretta e preme Invio alla fine. Punta e spara, il codice arriva da solo. Il campo e' in sola lettura apposta - ci compare l'ultimo codice letto, ma non si scrive a mano.",
			key: 'scan',
			placement: 'bottom',
			target: at('scan'),
			title: 'Come si legge un codice',
		},
		{
			body: "Se la pistola non c'e' o il computer e' lontano, il telefono fa da lettore: premi LEGGI CON IL TELEFONO, inquadra il QR che compare e sul telefono si apre la fotocamera - niente app da installare. Legge EAN-13 ed EAN-8, UPC, Code128, Code39, QR e DataMatrix. Ogni codice va confermato con INVIA sul telefono, cosi' un doppio scatto non passa inosservato. Il collegamento resta attivo anche passando alle altre pagine del magazzino, finche' non premi DISCONNETTI. Il codice inviato fa esattamente quello che fa la pistola: scarica un pezzo.",
			key: 'phone',
			placement: 'bottom',
			target: at('phone'),
			title: 'Leggere con il telefono',
		},
		{
			body: "Come nel Carico, lo scarico e' gia' avvenuto quando compare la riga verde: nessun pulsante da premere, nessun annulla. Qui pero' c'e' una conseguenza in piu': se la giacenza scende fino alla soglia di riordino impostata sulla variante, parte in automatico una notifica che avvisa che quel prodotto va riordinato. La trovi nella campanella in alto.",
			key: 'done',
			placement: 'top',
			target: at('done'),
			timeout: 250,
			title: "Lo scarico e' immediato, e puo' avvisare",
		},
		{
			body: "La riga mostra cosa hai scaricato: foto, nome, sku ed ean, le caratteristiche della variante e la quantita' a magazzino gia' aggiornata. E' il modo per controllare a colpo d'occhio di aver letto il prodotto giusto. Se il codice non corrisponde a nulla, al suo posto compare un avviso rosso e non viene scaricato niente.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			timeout: 250,
			title: 'Cosa hai appena scaricato',
		},
		{
			body: "Puo' capitare che lo stesso codice stia su piu' varianti: in quel caso il sistema non sceglie per te e non scarica niente. Compaiono tutte le candidate, ognuna con due pulsanti - EAN e SKU - e lo scarico parte solo quando indichi tu quale delle due letture vale. E' l'unico caso in cui questa pagina chiede una conferma.",
			key: 'choose',
			placement: 'left',
			target: at('choose'),
			timeout: 250,
			title: "Quando il codice e' ambiguo",
		},
	];
}
